import { ChatActions } from "../chats/types";
import { UiChatTab } from "./types";

const initialState: UiChatTab = {
    fetching: false,
    ids: []
}

export function uiChatTab(state: UiChatTab = initialState, action: ChatActions): UiChatTab {
    switch(action.type) {
        case 'chats/fetch-request':
            return {...state, fetching: true };

        case 'chats/fetch-error':
            return {...state, fetching: false };

        case 'chats/fetch-success':
        case 'chats/create-success':
            return {...state, fetching: false, ids: uniqueIds(state.ids, action.data.result) };

        case 'chats/chat-notification':
            return { ...state, ids: uniqueIds(state.ids, [action.data.id]) }

        default:
            return state;
    }
}

function uniqueIds(existing_ids: string[], new_ids: string[]) {
    const allIds = [...existing_ids, ...new_ids];
    const s = new Set(allIds);
    return Array.from(s).sort();
}